import SubAccordionItemHandler from '@/components/forms/new/SubAccordionItemHandler';
import UserCustomAttributes from './UserPlatformAttributes';

const UserCollapsableAttributes = ({
    index,
    errors,
    touched,
    darkMode,
    platformIndex,
    isLastItem,
}) => {
    return (
        <SubAccordionItemHandler
            index={index}
            key="customAttributes"
            label="Attributes"
            isLastItem={isLastItem}>
            {[1, 2, 3].map((num) => (
                <UserCustomAttributes
                    key={`platformAttribute${num}`}
                    errors={errors}
                    touched={touched}
                    darkMode={darkMode}
                    number={num}
                    platformIndex={platformIndex}
                />
            ))}
        </SubAccordionItemHandler>
    );
};

export default UserCollapsableAttributes;
